import src from "IMAGE";
export default { src, width: 260, height: 80, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AKSklIO8nISsvsOtq7PFwayvwsCstca+q6C6uKyctKiGAKeml4fAnoaxwsawsbfIxbGyxcSxuMnDsaG7vLGetquKlPortLAHzGUAAAAASUVORK5CYII="};
